import { Component, OnInit } from '@angular/core';
import { Lifecycle } from '../../../../_helpers/Lifecycle/Lifecycle.class';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
//import { CategoryEditModalComponent } from '../category/category-edit-modal/category-edit-modal.component';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { Constants } from '../../../../_utils/Constants';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { APIEntityService } from '../../_services/entity/API-entity';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  today = new Date();



  constructor(
    private db: $DBManagerService,
    private evt: $BroadcastManagerService,
    private es: APIEntityService
  ) { }

  ngOnInit(): void {
    this.db.clearDB();
    this.evt.emit({ 'click': 'HEADER_EVENT' });
  }

  downloadHeaderReports() {
    this.today.setDate(this.today.getDate() - 1);

    var yesterday = formatDate(this.today, 'dMyyyy', 'en-US');

    // let fileName = 'List_of_Registered_Headers_on_DLT_' + yesterday + '.pdf';
    let fileName = 'HeaderDLTReport.zip';
    this.es.downloadDLTReport('Header').subscribe(r => {
      importedSaveAs(r, fileName)
    })
  }



  downloadEntityReports() {
    this.today.setDate(this.today.getDate() - 1);

    var yesterday = formatDate(this.today, 'dMyyyy', 'en-US');
    // let fileName = 'List_of_Registered_PE_on_DLT_' + yesterday + '.pdf';
    let fileName = 'EntityDLTReport.zip';
    this.es.downloadDLTReport('Entity').subscribe(r => {
      importedSaveAs(r, fileName)
    })
  }

  downloadPrivacyprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/Privacy Policy.pdf';
    link.download = 'Privacy Policy Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  downloadTermsprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/Terms of Use.pdf';
    link.download = 'Terms of Use Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

}
